
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import useAppRoleAdd from '@/modules/role/app/model/add';
import { ROUTE_NAME_ROLE } from '@/modules/role/router';

export default defineComponent({
    name: ROUTE_NAME_ROLE.APP.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard },
    setup() {
        const { model, v$, roleOption, addAppRole } = useAppRoleAdd();

        return { v$, model, roleOption, addAppRole };
    }
});
